import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import FoodFeaturedPreview from './FoodFeaturedPreview';

export default function FoodFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={FoodFeaturedPreview}
        />
    );
}